<template>
<b-container fluid class="container">

<div v-if="this.errorConexion == true" >
        <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
              <div class="row justify-content-center ">
                <div class="col-sm-9 text-center mb-2">
                  <h1 class="style-nissan">Ha ocurrido un error de Conexión.</h1>
                  <p>Vuelve intentar mas tarde.</p>
                    <img src="../assets/error_conexion.png" class="img-fluid" width="250px" height="auto" alt="" />
                    <div>
                        <p>Puedes contactarnos a <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> 800-022-5425</p>
                    </div>
                  <div>
                     <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                     <p>Error Service autocomcube.</p>
                  </div>

                </div>
              </div>
          <template #overlay>
            <div class="text-center">
              <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
              <h6>Cargando ...</h6>
            </div>
          </template>
        </b-overlay>
</div>

<div v-if="this.unidadNoEncontrada == true" >
        <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
              <div class="row justify-content-center ">
                <div class="col-sm-9 text-center mb-2">
                  <h1 class="style-nissan">Esta unidad ya no existe en nuestro inventario.</h1>
                  <p>Puedes regresar a nuestro catálogo.</p>
                    <img src="../assets/NoEncontrada.png" class="img-fluid" width="270px" height="auto" alt="" />
                  <div>
                     <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                  </div>

                </div>
              </div>
          <template #overlay>
            <div class="text-center">
              <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
              <h6>Cargando ...</h6>
            </div>
          </template>
        </b-overlay>
</div>

<div v-if="this.unidadNoDisponible == true" >
        <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
              <div class="row justify-content-center ">
                <div class="col-sm-9 text-center mb-2">
                  <h1 class="style-nissan">La unidad no se encuentra disponible.</h1>
                  <p>Puedes regresar a nuestro catálogo.</p>
                    <img src="../assets/NoDisponible.png" class="img-fluid" width="270px" height="auto" alt="" />
                  <div>
                     <b-button @click.prevent="regresar()" class="button_bk">REGRESAR</b-button>
                  </div>

                </div>
              </div>
          <template #overlay>
            <div class="text-center">
              <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
              <h6>Cargando ...</h6>
            </div>
          </template>
        </b-overlay>
</div>

<div v-if="this.inicial == true">

      <!-- Imagenes -->
      <b-row class="justify-content-md-center">
        <b-overlay :show="overlayI" variant="light" opacity="0.97" rounded="sm">
          <b-col v-if="photos.length === 0 " class="card-body">
            <carousel :per-page="1" :autoplay="true" :paginationEnabled="false" :loop="true" >
              <slide >
                <img src="../assets/auto1.png" class="img-fluid" width="470px" height="310px" alt="" />
              </slide>
            </carousel>
          </b-col>

          <b-col class="card-body" v-if="photos.length > 0">
            <carousel :per-page="1" :autoplay="true" :paginationEnabled="false" :loop="true" >
              <slide v-for="photo in photos" :key="photo.id">
                <img :src="photo.url" width="auto" height="310px" alt="" />
              </slide>
            </carousel>
          </b-col>

          <template #overlay>
            <div class="text-center">
              <img src="../assets/car-2.png" class="img-fluid spinner-grow text-light">
              <h6>Cargando ...</h6>
            </div>
          </template>
        </b-overlay>
      </b-row>

    <!-- Información del Auto -->
   <b-row class="justify-content-md-center">
      <b-row v-if="autos.length === 0">
        <b-col class="card-body text-left" >
          <h1>UNIDAD NO ENCONTRADA EN NUESTRO INVENTARIO</h1>
        </b-col>
      </b-row>

      <b-row v-if="autos.length > 0 & this.type == 'U'">
        <b-row v-for="auto in autos" :key="auto.id">
          <b-col col md="8" class="card-body text-left margen3">
            <p class="detalles margen4">VIN: {{auto.vin}} <br> Número de inventario: {{auto.id}} </p>
            <h1 class="card-title" style="margin-bottom: 65px;">
              {{ auto.modelYear }} {{ auto.brandDescription }}
              {{ auto.modelDescription }}, {{ auto.trimDesciption }},
              {{ auto.doors}} PUERTAS, {{formatPrice(auto.mileage)}} kms 
            </h1>
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2">
                <b-col class="mb-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/body-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">CATEGORÍA</b-col>
                          <b-col> <h6 class="h642">{{auto.bodyType}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mb-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/engine-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">MOTOR</b-col>
                          <b-col> <h6 class="h642">{{auto.fuel}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mt-1">
                    <b-row cols="2">
                      <b-col cols="3">
                        <b-img class="imgs" src="../assets/colors-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col cols="9">
                        <b-row cols="1" class="text-left">
                          <b-col cols="12" class="h64">COLOR EXT / INT</b-col>
                          <b-col> <h6 class="h642">{{auto.colourDescription}} / {{auto.upholsteryDescription}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mt-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/transmission-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">TRANSMISIÓN</b-col>
                          <b-col> <h6 class="h642">{{auto.gearboxType}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
              </b-row>            
          </b-col>
          <b-col col md="4" class="margen2">
            <p class="detalles" style="margin-top: 40px;">*NOTA: Nuestro inventario se actualiza diariamente, por favor consulte con <span style="color: #172546;"> <b>ClikAuto</b></span> <span style="color: #51AED3;"> <b>Mobility</b></span> para confirmar la disponibilidad de vehículos</p>
          </b-col>
        </b-row>
      </b-row>

      <b-row v-if="autos.length > 0 & this.type == 'N'">
        <b-row v-for="auto in autos" :key="auto.id">
          <b-col col md="8" class="card-body text-left margen3">
            <p class="detalles margen4">VIN: {{auto.vin}} <br> Número de inventario: {{auto.id}} </p>
            <h1 class="margen3 card-title" style="margin-bottom: 65px;">
              {{ auto.modelYear }} {{ auto.brandDescription }}
              {{ auto.modelDescription }}, {{ auto.trimDesciption }},
              {{ auto.doors}} PUERTAS, 0 kms
            </h1>
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2">
                <b-col class="mb-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/body-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">CATEGORÍA</b-col>
                          <b-col> <h6 class="h642">{{auto.bodyType}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mb-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/engine-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">MOTOR</b-col>
                          <b-col> <h6 class="h642">{{auto.fuel}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mt-1">
                    <b-row cols="2">
                      <b-col cols="3">
                        <b-img class="imgs" src="../assets/colors-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col cols="9">
                        <b-row cols="1" class="text-left">
                          <b-col cols="12" class="h64">COLOR EXT / INT</b-col>
                          <b-col> <h6 class="h642">{{auto.colourDescription}} / {{auto.upholsteryDescription}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col class="mt-1">
                    <b-row cols="2" >
                      <b-col cols="3" class="text-left">
                        <b-img class="imgs" src="../assets/transmission-icon.png" alt=""></b-img>
                      </b-col>
                      <b-col>
                        <b-row cols="1" class="text-left">
                          <b-col class="h64">TRANSMISIÓN</b-col>
                          <b-col> <h6 class="h642">{{auto.gearboxType}}</h6></b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-col>
              </b-row>            
          </b-col>
          <b-col col md="4" class="margen2">
            <p class="detalles" style="margin-top: 60px;">*NOTA: Nuestro inventario se actualiza diariamente, por favor consulte con <b>ClikAuto Mobility</b> para confirmar la disponibilidad de vehículos</p>
          </b-col>
        </b-row>
      </b-row>
    </b-row>


<!-- Suscripciones Largas --> 
<div v-if="this.botonesL == true">
  <Largas/>
</div>

<!-- Suscripciones Cortas Usados --> 
<div v-if="this.botonesC == true">
  <SuscripcionCortas/>
</div>

<!-- Suscripciones Largas Usados --> 
<div v-if="this.botonesLU == true">
  <LargasUsados/>
</div>


</div>
      <b-overlay :show="overlayG" variant="light" opacity="0.90" rounded="sm" no-wrap>
          <template #overlay>
            <div class="text-center">
              <b-spinner style="color:#51AED3" type="grow" label="Spinning"></b-spinner>
              <h2>Cargando ...</h2>
            </div>
          </template>
      </b-overlay>

</b-container>
</template>

<script>
import Largas from './Largas.vue';
import LargasUsados from './LargasUsados.vue';
import SuscripcionCortas from './SuscripcionCortas.vue';

export default {
  name: 'Autocom',

  components: {
    Largas,
    SuscripcionCortas,
    LargasUsados
  },

    data() {
    return {
      inicial: false,
      overlayG:true,
      overlayI:false,
      botonesC: false,
      botonesL: false,
      botonesLU: false,
      unidadNoDisponible:false,
      unidadNoEncontrada: false,
      errorConexion: false,

      contents: null,
      autos: [],
      photos: [],
      vin: this.$route.query.vin,
      type: this.$route.query.type,
      kilometros: '',
      timeout: null,

      };
  },

  methods: {

    iframeGoVirtual(){
      let message = { height: document.body.scrollHeight+50, width: document.body.scrollWidth }; 

      // window.top refers to parent window
      window.top.postMessage(message, "*");
      console.log('iFrame Go virtual -->',message);
    },

    clearTimeout() {
        if (this.timeout) {
          clearTimeout(this.timeout)
          this.timeout = null
        }
    },

    setTimeout(callback) {
        this.clearTimeout()
        this.timeout = setTimeout(() => {
          this.clearTimeout()
          callback()
        }, 5000);
    },

    tokenStock(){
      let user = {
      username: "desarrolloti@autocom.mx",
      password: "Autocom2021"};

    //axios.post("https://pruebas.autocomcube.mx/api/token/login", user)
    axios.post("https://autocomcube.mx/api/token/login", user) //PRO
      .then((response) => {
        this.contents = response.data.token;
              if(this.contents != null){
                 sessionStorage.setItem("tokenStock", response.data.token);   
                 this.cargarInfoVehiculo();             
              }
        }).catch(error => {
          this.errorConexion = true;
          this.unidadNoDisponible = false;
          this.unidadNoEncontrada = false;
          this.inicial = false;
          this.overlayG = false;
          this.overlayI = true;
          this.setTimeout(() => {
          this.overlayI = false;});
          console.log('Error de API Inventario Token --> ',error);
        });
    },
    cargarInfoVehiculo(){
      //  console.log('Tipo --->',this.type);
      //  console.log('Vin --->',this.vin);
      sessionStorage.setItem("vinUnidad", this.vin);
      sessionStorage.setItem("typeUnidad", this.type);

      if( this.$route.query.type == 'U'){
          this.autosSeminuevos();
       } else if( this.$route.query.type == 'N'){
          this.autosNuevos();
      }
    },

    autosNuevos(){
              //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin},
            }).then((response) => {
              this.estatusN = response.data.newstock.length;
              if( this.estatusN != 0){
                  console.log('Estatus N-->',this.estatusN);
                  this.model = response.data.newstock[0].modelDescription;
                  if( this.model == null){
                      this.unidadNoEncontrada = false;
                      this.unidadNoDisponible = true;
                      this.inicial = false;
                      this.overlayG = false;
                      this.overlayI = true;
                      this.setTimeout(() => {
                      this.overlayI = false;});
                  } else {
                      this.TipoSuscri = response.data.newstock[0].newsuscriptionDetails.tags;
                      sessionStorage.setItem("Tags", this.TipoSuscri);
                      this.kilometros = 0;
                      sessionStorage.setItem("kilometrosP", this.kilometros);
                      sessionStorage.setItem("tipoAutoP", 'Auto Nuevo');
                      sessionStorage.setItem("TipoVehiculo", 1);
                      if( this.TipoSuscri == 'LARGA'){
                        this.autos = response.data.newstock;
                        this.photos = response.data.newstock[0].photos.photos_;
                        this.cargarLargas();
                      }                    
                  }
              } else {
                this.unidadNoDisponible = false;
                this.unidadNoEncontrada = true;
                this.inicial = false;
                this.overlayG = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
              }
            }).catch(error => {
          this.errorConexion = true;
          this.unidadNoDisponible = false;
          this.unidadNoEncontrada = false;
          this.inicial = false;
          this.overlayG = false;
          this.overlayI = true;
          this.setTimeout(() => {
          this.overlayI = false;});
          console.log('Error de API Inventario Nuevos --> ',error);
        });      
    },

    autosSeminuevos(){
        // console.log('Seminuevo');
              //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            }).then((response) => {
              this.estatusU = response.data.usedstock.length;
              // console.log('Estatus 1-->',this.estatusU)
              if( this.estatusU != 0){
                  this.autos = response.data.usedstock;
                  this.photos = response.data.usedstock[0].spincarphotos.photos;
                  this.TipoSuscri = response.data.usedstock[0].suscriptionDetails.tags;
                  sessionStorage.setItem("Tags", this.TipoSuscri);
                  this.kilometros = response.data.usedstock[0].mileage;
                  sessionStorage.setItem("kilometrosP", this.kilometros);
                  sessionStorage.setItem("tipoAutoP", 'Auto Seminuevo');
                  sessionStorage.setItem("TipoVehiculo", 2);
                //  console.log('tipo -->',this.TipoSuscri);
                    if( this.TipoSuscri == 'CORTA'){
                        this.cargarCortas();
                    } else if(this.TipoSuscri == 'LARGA'){
                        this.cargarLargasSeminuevos();
                    }
              } else {
                this.unidadNoDisponible = false;
                this.unidadNoEncontrada = true;
                this.overlayG = false;
                this.overlayI = true;
                this.setTimeout(() => {
                this.overlayI = false;});
              }
            }).catch(error => {
          this.errorConexion = true;
          this.unidadNoDisponible = false;
          this.unidadNoEncontrada = false;
          this.inicial = false;
          this.overlayG = false;
          this.overlayI = true;
          this.setTimeout(() => {
          this.overlayI = false;});
          console.log('Error de API Inventario SemiNuevos --> ',error);
        });
    },

    cargarLargas(){
      this.overlayG = false;
      this.inicial = true;
      this.overlayI = true;
      this.setTimeout(() => {
        this.overlayI = false;
      });
      this.botonesL = true;
    },

    cargarLargasSeminuevos(){
      this.overlayG = false;
      this.inicial = true;
      this.overlayI = true;
      this.setTimeout(() => {
        this.overlayI = false;
      });
      this.botonesLU = true;
    },

    cargarCortas(){
      this.overlayG = false;
      this.inicial = true;
      this.overlayI = true;
      this.setTimeout(() => {
        this.overlayI = false;
      });
      this.botonesC = true;
    },

    regresar(){
      window.history.go(-1);
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    getVin() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const vin = urlParams.get('vin');
    return vin;
    },

    getUrlYear() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const year = urlParams.get('year');
    return year;
    },

    getUrlmake() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const make = urlParams.get('make').toUpperCase();
    return make;
    },

    getUrlmodel() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const model = urlParams.get('model').toUpperCase();
    return model;
    },

    getUrltrim() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const trim = urlParams.get('trim').replace(/%20/g," ").toUpperCase();
    return trim;
    },

    getUrlPrice() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const price = urlParams.get('price');
    this.precio = parseInt(price);
    return price;
    },

    getUrlColor() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const color = urlParams.get('extcolor').toUpperCase();
    return color;
    },
    
    getUrlKms() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const kms = urlParams.get('mileage');
    return kms;
    },

    getType() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const type = urlParams.get('type');
    return type;
    },


  },

  created() {
    this.tokenStock();
    this.iframeGoVirtual();
   },

}
</script>

<style scoped>


</style>